import { render, staticRenderFns } from "./activeCheckTheCollection.vue?vue&type=template&id=575fe704"
import script from "./activeCheckTheCollection.vue?vue&type=script&lang=js"
export * from "./activeCheckTheCollection.vue?vue&type=script&lang=js"
import style0 from "./activeCheckTheCollection.vue?vue&type=style&index=0&id=575fe704&prod&lang=less&scope=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports